import { usePopup } from "hooks/usePopup"
import { useSoundPath } from "hooks/useSoundPath";

const ActiveItemCancelListing = () => {

  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const cancelListingHandler = () => {
    setPopupHook({type: 'cancel-listing-default'});
    playSound('main')
  }

  return (
    <button className="card-details__button" onClick={cancelListingHandler}>Cancel listing</button>
  )
}

export default ActiveItemCancelListing
